import { useEffect, useState } from "react";
import { api, VERSES } from "../lib/api";
import { Reveal } from "./Reveal";
import { ArchWindow } from "./ArchWindow";

export const VerseOfDay = () => {
  const [verse, setVerse] = useState(null);
  const [reflection, setReflection] = useState(null);
  const [reflectionState, setReflectionState] = useState("loading");

  useEffect(() => {
    api.get("/verses/today")
      .then((r) => setVerse(r.data))
      .catch(() => setVerse({ reference: VERSES[1].ref, text: VERSES[1].text }));
    api.get("/verses/today/reflection")
      .then((r) => { setReflection(r.data); setReflectionState("ready"); })
      .catch(() => setReflectionState("error"));
  }, []);

  const dateLabel = new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });

  return (
    <section id="verse" className="py-24 relative overflow-hidden bg-[#FFF5F2]">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse at center, rgba(232,76,76,0.12) 0%, transparent 65%)" }} />
      <div className="max-w-4xl mx-auto px-6 text-center relative" data-testid="verse-of-day-section">
        <Reveal>
          <div className="flex justify-center"><ArchWindow size={34} bar="#FFF5F2" /></div>
          <p className="mt-6 font-orbitron text-xs tracking-[0.4em] text-[#E84C4C]">VERSE OF THE DAY</p>
          <p className="mt-2 text-xs tracking-widest uppercase text-[#120716]/45" data-testid="verse-of-day-date">{dateLabel}</p>
          <blockquote
            className="mt-8 font-montserrat italic font-light text-xl sm:text-2xl md:text-3xl text-[#120716] leading-relaxed min-h-[4.5rem]"
            data-testid="verse-of-day-text"
          >
            {verse ? `"${verse.text}"` : ""}
          </blockquote>
          <cite className="block mt-8 font-orbitron text-sm tracking-[0.4em] text-[#E84C4C] not-italic uppercase" data-testid="verse-of-day-ref">
            {verse?.reference || ""}
          </cite>
          <div className="mt-12 mx-auto max-w-2xl text-left glass rounded-2xl p-7 md:p-8" data-testid="verse-reflection">
            <div className="flex items-center gap-3">
              <ArchWindow size={12} />
              <span className="font-orbitron text-[10px] tracking-[0.35em] text-[#E84C4C]">TODAY'S REFLECTION</span>
            </div>
            {reflectionState === "loading" && (
              <p className="mt-4 text-sm text-[#120716]/45 italic" data-testid="verse-reflection-loading">Preparing today's reflection...</p>
            )}
            {reflectionState === "ready" && (
              <p className="mt-4 text-sm md:text-base text-[#120716]/75 leading-relaxed whitespace-pre-line" data-testid="verse-reflection-text">{reflection.text}</p>
            )}
            {reflectionState === "error" && (
              <p className="mt-4 text-sm text-[#120716]/45 italic" data-testid="verse-reflection-error">Today's reflection will be here shortly. Sit with the verse for a moment in the meantime.</p>
            )}
            <p className="mt-5 text-[11px] tracking-widest uppercase text-[#120716]/40">Luke Adams · Digital Missions</p>
          </div>
          <p className="mt-8 text-xs text-[#120716]/45">Chosen by Luke. A new verse and reflection every morning.</p>
        </Reveal>
      </div>
    </section>
  );
};
